export default new URLSearchParams(window.location.search).get('output') || 'qmusic_nl_kijk_live_main'
